var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountsCases(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FCDFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 9.875C18.664 9.875 16.7064 10.4688 15.0414 11.5814C13.3763 12.6939 12.0786 14.2752 11.3122 16.1253C10.5459 17.9754 10.3454 20.0112 10.7361 21.9753C11.1267 23.9393 12.091 25.7435 13.5071 27.1595C14.9231 28.5755 16.7272 29.5398 18.6912 29.9305C20.6553 30.3211 22.6911 30.1206 24.5412 29.3543C26.3913 28.5879 27.9726 27.2902 29.0851 25.6251C30.1977 23.9601 30.7915 22.0025 30.7915 20C30.7885 17.3156 29.7208 14.742 27.8227 12.8438C25.9245 10.9457 23.3509 9.87798 20.6665 9.875ZM28.5415 20C28.5431 21.7 27.992 23.3544 26.9712 24.7137L15.9528 13.6953C17.1231 12.8208 18.5136 12.2891 19.9689 12.1597C21.4241 12.0303 22.8866 12.3082 24.1929 12.9624C25.4992 13.6167 26.5978 14.6214 27.3658 15.8642C28.1337 17.1071 28.5408 18.539 28.5415 20ZM12.7915 20C12.7899 18.3 13.341 16.6456 14.3618 15.2863L25.3803 26.3047C24.2099 27.1792 22.8194 27.7109 21.3642 27.8403C19.9089 27.9697 18.4464 27.6918 17.1401 27.0376C15.8338 26.3834 14.7352 25.3786 13.9673 24.1358C13.1993 22.8929 12.7922 21.461 12.7915 20Z",
    fill: "#B42318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsCases);
export default __webpack_public_path__ + "static/media/accountsCases.d496e703e8b175688edb3759c63bffb3.svg";
export { ForwardRef as ReactComponent };